import form from './form.fr';
import table from './table.fr';
import fileForm from './fileForm.fr';
import folderForm from './folderForm.fr';
import uploadFormPopup from './uploadFormPopup.fr';
export default {
    table,
    folderForm,
    uploadFormPopup,
    fileForm,
    form,
    breadcrumb: 'Repository',
};
